// extracted by mini-css-extract-plugin
module.exports = {"power-backup":"battery-backup-for-home_power-backup__RnUid"};